module.exports = __webpack_public_path__ + "0870f70b519359e4edec0df1ad116637.jpg";